/* istanbul ignore file */
import React from 'react';
import LeavesBreadcrumbs from 'domain/people/leave/shared/LeavesBreadcrumbs';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const CreateLeaveBreadcrumbs = () => {
  return (
    <LeavesBreadcrumbs>
      <CreateBreadcrumbItem entity="Leave" />
    </LeavesBreadcrumbs>
  );
};

export default CreateLeaveBreadcrumbs;
